// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: robot_interfaces/msg/Location.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PoseStamped } from "../../geometry_msgs/msg/PoseStamped";
import { NavSatFix } from "../../sensor_msgs/msg/NavSatFix";

export const protobufPackage = "robot_interfaces.msg.pb";

/** Location */
export interface Location {
  pose: PoseStamped | undefined;
  gps: NavSatFix | undefined;
}

function createBaseLocation(): Location {
  return { pose: undefined, gps: undefined };
}

export const Location: MessageFns<Location> = {
  encode(message: Location, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pose !== undefined) {
      PoseStamped.encode(message.pose, writer.uint32(2178065034).fork()).join();
    }
    if (message.gps !== undefined) {
      NavSatFix.encode(message.gps, writer.uint32(2807254034).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Location {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 272258129: {
          if (tag !== 2178065034) {
            break;
          }

          message.pose = PoseStamped.decode(reader, reader.uint32());
          continue;
        }
        case 350906754: {
          if (tag !== 2807254034) {
            break;
          }

          message.gps = NavSatFix.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Location {
    return {
      pose: isSet(object.pose) ? PoseStamped.fromJSON(object.pose) : undefined,
      gps: isSet(object.gps) ? NavSatFix.fromJSON(object.gps) : undefined,
    };
  },

  toJSON(message: Location): unknown {
    const obj: any = {};
    if (message.pose !== undefined) {
      obj.pose = PoseStamped.toJSON(message.pose);
    }
    if (message.gps !== undefined) {
      obj.gps = NavSatFix.toJSON(message.gps);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Location>, I>>(base?: I): Location {
    return Location.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Location>, I>>(object: I): Location {
    const message = createBaseLocation();
    message.pose = (object.pose !== undefined && object.pose !== null)
      ? PoseStamped.fromPartial(object.pose)
      : undefined;
    message.gps = (object.gps !== undefined && object.gps !== null) ? NavSatFix.fromPartial(object.gps) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
